var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 1 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34243 0.791698C7.72234 0.0219072 8.82004 0.0219087 9.19995 0.791698L11.1221 4.68636L15.4201 5.3109C16.2696 5.43434 16.6088 6.47831 15.9941 7.07751L12.884 10.1091L13.6182 14.3897C13.7633 15.2358 12.8753 15.881 12.1154 15.4815L8.27119 13.4605L4.42693 15.4815C3.6671 15.881 2.77905 15.2358 2.92416 14.3897L3.65835 10.1091L0.54828 7.07751C-0.0664339 6.47831 0.272774 5.43434 1.12229 5.3109L5.4203 4.68636L7.34243 0.791698ZM8.27119 1.33077L6.37278 5.17737C6.22191 5.48306 5.93029 5.69493 5.59295 5.74395L1.34797 6.36078L4.41967 9.35495C4.66377 9.59289 4.77516 9.93571 4.71753 10.2717L3.9924 14.4995L7.78923 12.5034C8.09096 12.3448 8.45142 12.3448 8.75315 12.5034L12.55 14.4995L11.8248 10.2717C11.7672 9.93571 11.8786 9.59289 12.1227 9.35495L15.1944 6.36078L10.9494 5.74395C10.6121 5.69493 10.3205 5.48306 10.1696 5.17737L8.27119 1.33077Z",
    fill: "#49484D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.a7095057343d7e52363733ef38b652d5.svg";
export { ForwardRef as ReactComponent };